export default {
  importFromExcel: '从Excel导入',
  downloadTheTemplate: '下载模板',
  uploadTheFile: '上传文件',
  finish: '完成',
  clickTheIconToDownloadTheTemplateFill: '点击图标下载模板,填写信息如已下载完成,点击',
  next: '下一步',
  uploadTheFileTwo: '一次只能上传一个文件，或',
  clickUpload: '点击上传',
  downloadTheResults: '查看导入结果',
  theUploadIsSuccessful: '上传成功',
  cancel: '取消',
  previousStep: '上一步',
  theImportToExcelIsSuccessful: '导入excel成功',
  success: '成功',
  items: '条',
  failed: '失败',
  fileSizeMax: '上传文件大小不能超过',
  fileFormatError: '文件格式错误，请上传',
  file: '文件',
}
